import { useEffect, useId } from 'react';
import { Container, Row, Col } from '@geberit/gdds';

// styles
import styles from './crm-forms.module.scss';

// utils
import { Log } from 'services/log';
import { classNameBuilder } from 'utils/classNameBuilder';
import { buildSize, gridSizes } from 'utils/gridSize';
import { useGdds } from 'utils/hooks/use-gdds';

const CRM_FORM_WRAPPER_ID = 'crm-form-wrapper';

type CRMFormsProps = {
  htmlSnippet: string;
};

export function CrmForms({ htmlSnippet }: Readonly<CRMFormsProps>) {
  const id = useId();
  const isGdds = useGdds();

  function waitForD365MktForms() {
    let count = 0;
    return new Promise<void>((resolve, reject) => {
      const interval = setInterval(() => {
        count++;
        if (count > 100) {
          clearInterval(interval);
          reject('d365mktforms is not defined');
        }
        if (typeof window.d365mktforms !== 'undefined') {
          clearInterval(interval);
          resolve();
        }
      }, 100);
    });
  }

  useEffect(() => {
    waitForD365MktForms()
      .then(() => {
        const crmFormElement = document.createElement('div');
        crmFormElement.innerHTML = htmlSnippet;

        // extract attributes from the snippet
        const crmFormWrapper = crmFormElement.querySelector('[data-form-id]');
        if (crmFormWrapper) {
          const formId = crmFormWrapper.getAttribute('data-form-id');
          const formApiBaseUrl = crmFormWrapper.getAttribute('data-form-api-url');
          const formUrl = crmFormWrapper.getAttribute('data-cached-form-url');
          const eventId = crmFormWrapper.getAttribute('data-readable-event-id');

          if (formId && formApiBaseUrl && formUrl) {
            // create form
            const form = d365mktforms.createForm(formId, formApiBaseUrl, formUrl, {
              'data-readable-event-id': eventId ?? `crm-form-${id}`,
            });

            // append the form to the container
            const formContainer = document.getElementById(CRM_FORM_WRAPPER_ID);
            formContainer?.replaceWith(form);
          }
        }
      })
      .catch((error) => {
        Log.error(error);
      });
  }, [htmlSnippet, id]);

  return (
    <section className={classNameBuilder(styles['crm-forms'], 'crm-forms')}>
      <Container
        maxContentWidth={buildSize(isGdds ? gridSizes.gddsFullGrid : gridSizes.countryGrid)}
      >
        <Row justify="center">
          <Col>
            <div id={CRM_FORM_WRAPPER_ID} />
          </Col>
        </Row>
      </Container>
    </section>
  );
}
